export default "__VITE_PUBLIC_ASSET__cf65cbc6__"